import React, { Fragment, useState } from "react";

/* Components */
import InfoBlock from "../presentational/InfoBlock";
import Dialog from "./Dialog/Dialog";

/* Images */
import image4 from '../images/4.jpg';

const InjectionMoulds = () => {
    const [open, setOpen] = useState(false);
    const [typeImages, setTypeImages] = useState(null);
    const [title, setTitle] = useState(null);

    const handleOpen = (type, text) => {
        setTypeImages(type);
        setOpen(true);
        setTitle(`Шприцформи за ${text}`);
    }

    const handleClose = () => {
        setOpen(false);
        setTypeImages(null);
    }

    return (
        <Fragment>
            <InfoBlock title={"Висококачествени решения за нашите клиенти"}>
                <h2 style={{ fontSize: 20 }}>  Шприцформи за пластмасови изделия с: </h2>
                <ul style={{ listStyle: 'square', listStylePosition: 'inside' }}>
                    <li> Едно и повече гнезда, топлоканални системи, конструкции със сменяеми вложки, оптимално охлаждане, бърз производствен цикъл, висока продуктивност </li>
                    <li> Европейска стомана стандарт Р20, Ампколой, Молдмакс </li>
                    <li> Топлоканални системи на Синвентив, Инкое, ДМE и др. </li>
                    <li> Стандартизирани компоненти на Хаско, ДME, Педроти и др. </li>
                </ul>
            </InfoBlock>

            <InfoBlock title={"Цялостно обслужване на клиента"}>
                <div className="group space-between">
                    <img className="imageInjection" src={image4} alt="machine" />

                    <div>
                        <h2 style={{ fontSize: 20 }}>  Шприцформи за пластмасови изделия с: </h2>
                        <ul style={{ listStyle: 'square', listStylePosition: 'inside' }}>
                            <li> Разработка на дизайна на изделието </li>
                            <li> Разнообразни решения за конструиране и изработка на инструмента по изискванията на клиента </li>
                            <li> Отворен производствен цикъл, позволяващ модификации по време на производството </li>
                            <li> Възможност клиентите да контролират всеки етап от производствения процес </li>
                            <li> Изпитания на готовите инструменти и производство на изделия на шприцмашини Италтех, Енгел, Куази със сила на притискане от 1200t до 150t </li>
                        </ul>
                    </div>
                </div>
            </InfoBlock>

            <InfoBlock title={""}>
                <h2 style={{ fontSize: 20 }}> Отрасли на промишлеността: </h2>
                <p style={{ color: 'red', textDecoration: 'underline', textUnderlinePosition: 'under', textIndent: '20px', cursor: 'pointer' }} onClick={() => handleOpen('rigidPackage', 'твърди опаковки')}> Шприцформи за твърди опаковки </p>
                <h2 style={{ fontSize: 20 }}> За: селското стопанство, транспорт, хранително-вкусовата промишленост, хлебарство и млечни продукти, индустриални течности и т.н. </h2>
                <p style={{ color: 'red', textDecoration: 'underline', textUnderlinePosition: 'under', textIndent: '20px', cursor: 'pointer' }} onClick={() => handleOpen('householdProducts', 'битови изделия')}> Шприцформи за битови изделия </p>
                <p style={{ color: 'red', textDecoration: 'underline', textUnderlinePosition: 'under', textIndent: '20px', cursor: 'pointer' }} onClick={() => handleOpen('technicalProducts', 'технически изделия')}> Шприцформи за технически изделия </p>
                <p style={{ color: 'red', textDecoration: 'underline', textUnderlinePosition: 'under', textIndent: '20px', cursor: 'pointer' }} onClick={() => handleOpen('specialApplications', 'специални приложения')}> Шприцформи за специални приложения </p>
                <p style={{ color: 'red', textDecoration: 'underline', textUnderlinePosition: 'under', textIndent: '20px', cursor: 'pointer' }} onClick={() => handleOpen('medicalDevices', 'медицински изделия')}> Шприцформи за медицински изделия </p>
                <p style={{ color: 'red', textDecoration: 'underline', textUnderlinePosition: 'under', textIndent: '20px', cursor: 'pointer' }} onClick={() => handleOpen('sales', 'продажба')}> Шприцформи за продажба </p>
            </InfoBlock>

            <Dialog
                open={open}
                onClose={() => handleClose()}
                title={title}
                typeImages={typeImages}
            >
                <p>This is a custom dialog.</p>
            </Dialog>
        </Fragment>
    );
}

export default InjectionMoulds;
